<template>
  <div class="subs">
    <div class="subscribe">
      <el-button
        type="success"
        @click="centerDialogVisible = true"
      >Create your own plan</el-button
      >
    </div>
    <div class="popup-box">
      <el-dialog
        v-model="centerDialogVisible"
        :visible.sync="centerDialogVisible"
        width="60%"
        :modal="false"
        center
      >
        <div class="popup__title">
          Create Your Own Plan
          <span class="info"><img src="../assets/qsn-mark.svg" /> </span>
        </div>
        <div class="dis">
          Lorem Ipsum LoLorem Ipsum Lorem Lorem Ipsum Lorem Lorem Ipsum Lorem
          Lorem Ipsum Lorem Lorem Ipsum Lorem Lorem Ipsum Lorem rem
        </div>

        <div class="card-box">
          <div class="card-box-body">
            <div class="title">Partyline</div>
            <div class="price">
              $<span>{{ price }}</span>
              <span class="small-grey">{{ planDurationString }}</span>
            </div>
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick">
              <el-tab-pane
                label="Subscription"
                name="subscription">
                <!-- <el-dropdown>
          <el-button>
            Frequency
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>Frequency 1</el-dropdown-item>
              <el-dropdown-item>Frequency 2</el-dropdown-item>
              <el-dropdown-item>Frequency 3</el-dropdown-item>
              <el-dropdown-item>Frequency 4</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown> -->
                <el-select
                  v-model="frequency"
                  placeholder="Frequency"
                  @change="updateFrequencyDropdowns(frequency)"
                >
                  <el-option
                    v-for="(item, index) in optionFrequency"
                    :key="index"
                    :value="item.value"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
                <el-input
                  placeholder="Hours"
                  v-model="hours"></el-input>
                <el-input
                  placeholder="Participants (Up to)"
                  v-model="participantsUpTo"
                ></el-input>
                <!--<el-dropdown>
          <el-button>
            ISO Outputs
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>ISO Output 1</el-dropdown-item>
              <el-dropdown-item>ISO Output 2</el-dropdown-item>
              <el-dropdown-item>ISO Output 3</el-dropdown-item>
              <el-dropdown-item>ISO Output 4</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown> -->

                <el-select
                  v-model="isoOutputs"
                  placeholder="ISO Outputs">
                  <el-option
                    v-for="(item, index) in isoOutputsOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-tab-pane>
              <el-tab-pane
                label="Prepaid"
                name="second">
                Prepaid
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="card-footer">
            <el-button>Subscribe Now</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      price: 0,
      planDurationString: '',
      optionFrequency: [
        { value: 'null', name: 'Frequency' },
        { value: 'monthly', name: 'Monthly' },
        { value: 'yearly', name: 'Yearly' }
      ],
      isoOutputs: null,
      // isoOutputsOptions: [
      //   { value: "null", name: "ISO Outputs" },
      //   { value: "isoOutput1", name: "ISO Outputs 1" },
      //   { value: "isoOutput2", name: "ISO Outputs 2" },
      //   { value: "isoOutput3", name: "ISO Outputs 3" },
      //   { value: "isoOutput4", name: "ISO Outputs 4" },
      // ],
      frequency: null,
      centerDialogVisible: false,
      activeName: 'subscription',
      hours: null,
      participantsUpTo: null
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    updateFrequencyDropdowns (val) {
      if (val == 'monthly') {
        this.price = 169
        this.planDurationString = 'per month'
      } else if (val == 'yearly') {
        this.price = 649
        this.planDurationString = 'per year'
      } else {
        this.price = 0
        this.planDurationString = ''
      }
    }
  },
  computed: {
    isoOutputsOptions () {
      return []
    }
  }
}
</script>
<style>
/* .el-scrollbar ul {
  background: #e1e8ee !important;
  border: 2px solid #c8ced3;
  box-sizing: border-box;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  width: 260px;
}
.el-scrollbar ul li {
  color: #1e1e1e !important;
  font-weight: normal !important;
}
.el-scrollbar ul li:hover {
  background: none !important;
}
.el-scrollbar ul li span {
  color: #1e1e1e !important;
}
.el-popper__arrow::before {
  display: none !important;
}
.el-select__popper {
  background: none !important;
  border: none !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: none !important;
}
.subscribe {
  text-align: center;
} */
</style>
